// packages/app/src/components/home/CustomHomePage.tsx

import React from 'react';
import {
  Content,
  Page,
  Header,
  HeaderLabel,
  InfoCard
} from '@backstage/core-components';
import { HomePageStarredEntities,HeaderWorldClock,ClockConfig } from '@backstage/plugin-home';
import {
  SearchContextProvider,
  SearchBar,
} from '@backstage/plugin-search-react';
import { Grid, Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSearch } from '@backstage/plugin-search-react';
import { UserSettingsMenu } from '@backstage/plugin-user-settings'; 
import { useApi, configApiRef } from '@backstage/core-plugin-api';

const SearchWithNavigation = () => {
  const { setTerm } = useSearch();
  const navigate = useNavigate();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    if (event.key === 'Enter' && target.value.trim() !== '') {
      setTerm(target.value);             // 设置全局搜索词
      navigate('/search');               // 跳转到搜索页面
    }
  };

  return (
    <SearchBar
      placeholder="搜索组件、文档、API..."
      InputProps={{
        onKeyDown: handleKeyDown,
      }}
    />
  );
};

const clockConfigs: ClockConfig[] = [{
  label: '北京',
  timeZone: 'Asia/Shanghai'
  }, {
    label: '瑞典',
    timeZone: 'Europe/Stockholm'
  }, {
    label: '东京',
    timeZone: 'Asia/Tokyo'
  }];
const timeFormat: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
};


export const HomePage = () => {
  const config = useApi(configApiRef);
  const orgName = config.getString('organization.name');
  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Header title="欢迎来到 Xllent Backstage" subtitle="你的开发者门户">
          <HeaderWorldClock clockConfigs={clockConfigs} customTimeFormat={timeFormat} />
          <hr style={{height: 40}}/>
          <HeaderLabel label="Owner" value={orgName} />
          <HeaderLabel label="Environment" value="Production" />
          {/* 👇 用户菜单按钮在右上角 */}
          <div style={{ marginLeft: 'auto' }}>
            <UserSettingsMenu />
          </div>
        </Header>
        <Content>
          <Grid container spacing={3} >
            {/* 搜索框 */}
            <Grid item xs={12} md={12}>
              <SearchWithNavigation />
            </Grid>
            
            {/* 快捷入口卡片 */}
            <Grid item xs={12} md={6}>
              <InfoCard title="🚀 快捷入口">
                <Grid container spacing={2} direction="row" justifyContent="flex-start">
                <Grid item>
                    <Button variant="outlined" component={RouterLink} to="/catalog?filters[kind]=Domain">
                      Domain
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" component={RouterLink} to="/catalog?filters[kind]=System">
                      System
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" component={RouterLink} to="/catalog?filters[kind]=Component">
                      Components
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" component={RouterLink} to="/catalog?filters[kind]=API">
                      API
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" component={RouterLink} to="/catalog?filters[kind]=Resource">
                      Resources
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained" color="primary" component={RouterLink} to="/catalog-import">
                      导入新组件
                    </Button>
                  </Grid>
                </Grid>
                <Grid container spacing={2} direction="row" justifyContent="flex-start">
                  <Grid item></Grid>
                </Grid>
                <Grid container spacing={2} direction="row" justifyContent="flex-start">
                <Grid item>
                    <Button variant="outlined" component={RouterLink} to="https://github.com/orgs/aixllent/repositories" target="_blank">
                      Github仓库
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" component={RouterLink} to="https://github.com/aixllent/host-infra-compose/tree/main/backstage/xllent-ai" target="_blank">
                      编辑通用组件.yaml
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" component={RouterLink} to="/docs/default/component/backstage-app/">
                      Backstage 使用规范
                    </Button>
                  </Grid>                  
                </Grid>
              </InfoCard>
              <br/>
              {/* 收藏组件展示 */}
              <HomePageStarredEntities/>
            </Grid>
            {/* 组件模型 */}
            <Grid item xs={12} md={6}>
              <InfoCard>
                <img src="/software-model-entities.svg" alt="Backstage System Model" width="100%" height="100%" />
              </InfoCard>
            </Grid>
            <Grid item xs={12} md={6}>
              
            </Grid>
          </Grid>

        </Content>
      </Page>
    </SearchContextProvider>
  );
};
